import { render, staticRenderFns } from "./ServiceRoomsTable.vue?vue&type=template&id=ba2e11e4&"
import script from "./ServiceRoomsTable.vue?vue&type=script&lang=js&"
export * from "./ServiceRoomsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports